import React, { useState } from 'react';
import SimulatorView from './SimulatorView';
import type { Option, Tag } from './SimulatorForm';

type FormViewProps = {
  requestedFundingAmountOptions: Array<Option>;
  totalFundingAmountOptions: Array<Option>;
  currentValuationOptions: Array<Option>;
  previousPeriodSalesOptions: Array<Option>;
  financialStatusOptions: Array<Option>;
};

type Props = {
  type: string;
  presidentAgeOptions: Array<Option>;
  birthOnOptions: Array<Option>;
  businessTypeOptions: Array<Option>;
  fundraisingSimulationTags: Array<Tag>;
  ecf: FormViewProps;
  plus: FormViewProps;
  disableAccordion?: boolean;
};

const PageView = (props: Props) => {
  const [openAccordion, setOpenAccordion] = useState<'form1' | 'form2' | null>(
    null,
  );

  const toggleAccordion = (formId: 'form1' | 'form2' | null) => {
    setOpenAccordion(formId);
  };

  return (
    <div className="simulator__area">
      <SimulatorView
        {...props.ecf}
        presidentAgeOptions={props.presidentAgeOptions}
        birthOnOptions={props.birthOnOptions}
        businessTypeOptions={props.businessTypeOptions}
        fundraisingSimulationTags={props.fundraisingSimulationTags}
        type="ecf"
        tagSortKey="ecf_order"
        onToggleAccordion={() => toggleAccordion('form1')}
        onCloseAccordion={() => toggleAccordion(null)}
        isOpen={openAccordion === 'form1'}
        headerVariant="ecf"
      />

      <SimulatorView
        {...props.plus}
        presidentAgeOptions={props.presidentAgeOptions}
        birthOnOptions={props.birthOnOptions}
        businessTypeOptions={props.businessTypeOptions}
        fundraisingSimulationTags={props.fundraisingSimulationTags}
        type="plus"
        tagSortKey="plus_order"
        onToggleAccordion={() => toggleAccordion('form2')}
        onCloseAccordion={() => toggleAccordion(null)}
        isOpen={openAccordion === 'form2'}
        headerVariant="plus"
      />
    </div>
  );
};

const renderPageView = (props: Props) => {
  return <PageView {...props} />;
};

export default renderPageView;
